module.exports = __webpack_public_path__ + "img/icon-build.429948fe.png";